import { render, staticRenderFns } from "./schduling.vue?vue&type=template&id=9c2ffd48&scoped=true&"
import script from "./schduling.vue?vue&type=script&lang=js&"
export * from "./schduling.vue?vue&type=script&lang=js&"
import style0 from "./schduling.vue?vue&type=style&index=0&id=9c2ffd48&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c2ffd48",
  null
  
)

export default component.exports